export const GeoFailureCategory = {
	PERMISSION: 'permission',
	INTEGRITY: 'integrity',
	ERROR: 'error',
} as const satisfies Record<string, FailureCategory>
